import { render, staticRenderFns } from "./GoodsSendBack.vue?vue&type=template&id=4ff4661a&scoped=true&"
import script from "./GoodsSendBack.vue?vue&type=script&lang=js&"
export * from "./GoodsSendBack.vue?vue&type=script&lang=js&"
import style0 from "./GoodsSendBack.vue?vue&type=style&index=0&id=4ff4661a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff4661a",
  null
  
)

export default component.exports